import { HugeiconsIcon } from '@hugeicons/react'
import { Cancel01Icon } from '@hugeicons/core-free-icons'
import { Button } from '@/components/ui/button'

interface ReferenceCardProps {
  children: React.ReactNode
  icon?: React.ReactNode
  onRemove?: () => void
}

/** Box that displays a selected reference resource, with an optional remove button. */
export function ReferenceCard({
  children,
  icon,
  onRemove
}: ReferenceCardProps) {
  return (
    <div className='min-h-14 border-input mb-1 flex items-center gap-3 rounded-md border px-3 py-2'>
      {icon && <div className='shrink-0'>{icon}</div>}
      {children}
      {onRemove && (
        <Button
          type='button'
          variant='ghost'
          size='icon-sm'
          className='ml-auto'
          onClick={onRemove}
          aria-label='remove answer'
        >
          <HugeiconsIcon icon={Cancel01Icon} strokeWidth={2} />
        </Button>
      )}
    </div>
  )
}

/** Loading placeholder that matches the ReferenceCard chrome. */
export function ReferenceLoadingCard({ icon }: { icon?: React.ReactNode }) {
  return (
    <div className='min-h-14 border-input mb-1 flex items-center gap-3 rounded-md border px-3 py-2'>
      {icon && <div className='shrink-0'>{icon}</div>}
      <p className='text-muted-foreground'>Loading...</p>
    </div>
  )
}
